<template>
  <div class="admin-blogs-edit p-4 sm:p-6 lg:p-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Edit Post</h1>
        <p class="text-gray-600 mt-1">Update post information</p>
      </div>
      <Link
        :href="route('posts')"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
      >
        Back to List
      </Link>
    </div>

    <!-- Form -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
      <form @submit.prevent="submit">
        <div class="space-y-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Title *</label>
            <input
              v-model="form.title"
              type="text"
              required
              maxlength="150"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Type</label>
            <select
              v-model="form.type_id"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            >
              <option value="">Select a type</option>
              <option v-for="type in types" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Image</label>
            <img
              v-if="imagePreview"
              :src="imagePreview"
              alt="Preview"
              class="mb-3 w-32 h-32 rounded-lg object-cover border border-gray-200"
            />
            <input
              type="file"
              accept="image/*"
              @change="onFileChange"
              class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Details *</label>
            <textarea
              v-model="form.details"
              required
              rows="10"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            ></textarea>
            <p class="text-xs text-gray-500 mt-1">You can use HTML formatting</p>
          </div>

          <div class="flex items-center gap-2">
            <input
              id="is_active"
              v-model="form.is_active"
              type="checkbox"
              class="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
            />
            <label for="is_active" class="text-sm font-medium text-gray-700">Active</label>
          </div>

          <div class="flex items-center gap-4">
            <button
              type="submit"
              :disabled="submitting"
              class="px-6 py-3 bg-green-600 text-white rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-700"
            >
              {{ submitting ? 'Updating...' : 'Update Post' }}
            </button>
            <Link
              :href="route('posts')"
              class="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold transition-colors hover:bg-gray-300"
            >
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  components: {
    Link,
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: 'Edit Post',
    },
  },
  data() {
    return {
      form: useForm({
        title: this.post.title || '',
        type_id: this.post.type_id || '',
        image: null,
        is_active: !!this.post.is_active,
        details: this.post.details || '',
      }),
      imagePreview: this.post.image || null,
      submitting: false,
    }
  },
  methods: {
    onFileChange(e) {
      if (e.target.files.length) {
        this.form.image = e.target.files[0]
        this.imagePreview = URL.createObjectURL(e.target.files[0])
      }
    },
    submit() {
      this.submitting = true
      this.form.transform((data) => ({
        ...data,
        _method: 'put',
      })).post(route('posts.update', this.post.id), {
        onSuccess: () => {
          if (window.$toast) {
            window.$toast.success('Post updated successfully')
          }
        },
        onError: () => {
          this.submitting = false
        },
        onFinish: () => {
          this.submitting = false
        },
      })
    },
  },
}
</script>

<style scoped>
.admin-blogs-edit {
  min-height: 100vh;
  background-color: #f9fafb;
}
</style>
